import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { rebindWebflowIx2AfterInjectedHtml } from './components/webflow/wf-page-html.util';
import { IcortexRefProtocolService } from './services/icortex-ref-protocol.service';

declare var gtag: Function;

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: [ './app.component.css' ]
})
export class AppComponent {
  title = 'iCortex';

  constructor(
    public router: Router,
    private icortexRefProtocolService: IcortexRefProtocolService
  ) {

    this.icortexRefProtocolService.syncRefProtocolFromUrl();

    this.router.events.subscribe( event => {

      if ( event instanceof NavigationEnd ) {
        this.icortexRefProtocolService.syncRefProtocolFromUrl();
        gtag( 'config', 'UA-143549904-1', { 'page_path': event.urlAfterRedirects } );
        this.scrollViewportToTopAndReleaseBodyLock();
        this.scheduleWebflowRebindAfterRoute();
      }
    } );
  }

  /**
   * Tras cada navegación: ir al inicio del documento (evita quedar a mitad de página) y quitar bloqueo de scroll
   * que Webflow / `fs-scrolldisable-element` en el navbar puede dejar en body al abrir el menú y pulsar un enlace.
   */
  private scrollViewportToTopAndReleaseBodyLock(): void {

    const apply = (): void => {

      window.scrollTo( 0, 0 );
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    apply();

    requestAnimationFrame( () => {

      requestAnimationFrame( () => {

        apply();

        if ( document.body.style.overflow === 'hidden' ) {

          document.body.style.removeProperty( 'overflow' );
        }

        if ( document.documentElement.style.overflow === 'hidden' ) {

          document.documentElement.style.removeProperty( 'overflow' );
        }

        if ( document.body.style.position === 'fixed' ) {

          document.body.style.removeProperty( 'position' );
          document.body.style.removeProperty( 'top' );
          document.body.style.removeProperty( 'width' );
        }
      } );
    } );
  }

  /**
   * Webflow binds .w-nav / .w-dropdown on first load. Angular destroys the navbar on route change and mounts
   * a new DOM tree; without destroy → ready → ix2.init the Solutions / Technology menus stay inert off-home.
   */
  private scheduleWebflowRebindAfterRoute(): void {

    requestAnimationFrame( () => {

      requestAnimationFrame( () => {

        window.scrollTo( 0, 0 );
        rebindWebflowIx2AfterInjectedHtml();
      } );
    } );
  }

}
